// Must be the first import — registers the OTel provider and global error handlers
import "./instrumentation";
import "bootstrap/dist/css/bootstrap.min.css";
import "katex/dist/katex.min.css";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import "react-toastify/dist/ReactToastify.css";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "../src/client/Calculations/style.scss";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./i18n";
import "./index.css";
import { recordVital } from "./instrumentation";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store/store";

let persistor = persistStore(store);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<div>Loading ~~~</div>}>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </Suspense>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

reportWebVitals(recordVital);
